// extracted by mini-css-extract-plugin
export var hideEditor = "_m2-2";
export var infoIcon = "_m2-3";
export var label = "_m2-1";
export var labelContainer = "_m2-0";
export var readonlyText = "_m2-4";